import { render } from "./FeaturesCreate.vue?vue&type=template&id=7e616a72"
import script from "./FeaturesCreate.vue?vue&type=script&lang=js"
export * from "./FeaturesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__